import React from "react";
import { array } from "prop-types";

import NewsWithImage from "../../../molecules/NewsWithImage";

import "./organism1.m.css";

const Organism1 = ({ stories = [] }) => {
  if (!stories.length) {
    return null;
  }

  return (
    <div styleName="base">
      {stories.map((story, index) => (
        <NewsWithImage
          key={index}
          story={story}
          aspectRatio={[3, 2]}
          imageType="image3x2"
          showExcerpt={false}
          widths={[200, 300, 500]}
        />
      ))}
    </div>
  );
};

Organism1.propTypes = {
  stories: array.isRequired,
};

export default Organism1;
